module.exports = "<h1>Photo Binder</h1>\n\n"